import type { ICountriesPresentation } from '@/domain/statics/presentation/contract/ICountriesPresentation'

export class CouldNotGetCountriesPresentation implements ICountriesPresentation {
  constructor(
    public readonly message: string,
  ) {
  }
}
